export const CEP_BULK_PROCESSING_GET_REIMBURSABLE_ITEMS =
  'CEP_BULK_PROCESSING_GET_REIMBURSABLE_ITEM';
export const CEP_BULK_PROCESSING_LOADING = 'CEP_BULK_PROCESSING_LOADING';
export const CEP_BULK_PROCESSING_GET_MEAL_VALUES =
  'CEP_BULK_PROCESSING_GET_MEAL_VALUES';
export const CEP_BULK_PROCESSING_LOAD_ERROR = 'CEP_BULK_PROCESSING_LOAD_ERROR';
export const CEP_BULK_PROCESSING_WRITE_MEALS =
  'CEP_BULK_PROCESSING_WRITE_MEALS';
export const CEP_BULK_PROCESSING_GET_CEP_SITES =
  'CEP_BULK_PROCESSING_GET_CEP_SITES';
export const CEP_BULK_PROCESSING_CLEAR_ERROR =
  'CEP_BULK_PROCESSING_CLEAR_ERROR';
export const CEP_BULK_PROCESSING_LOADING_REIMBURSABLE_ITEMS =
  'CEP_BULK_PROCESSING_LOADING_REIMBURSABLE_ITEMS';
export const CEP_BULK_PROCESSING_SET_ISISPNULL =
  'CEP_BULK_PROCESSING_SET_ISISPNULL';
export const CEP_BULK_PROCESSING_GET_FISCAL_YEARS =
  'CEP_BULK_PROCESSING_GET_FISCAL_YEARS';
export const CEP_BULK_PROCESSING_SITES_LOADING = 'CEP_BULK_SITES_LOADING';
export const CEP_BULK_PROCESSING_CLEAR_WAS_WRITTEN =
  'CEP_BULK_PROCESSING_CLEAR_WAS_WRITTEN';
export const CEP_BULK_PROCESSING_LOADING_TOTAL_PARTICIPATION =
  'CEP_BULK_PROCESSING_LOADING_TOTAL_PARTICIPATION';
export const CEP_BULK_PROCESSING_SET_IS_DAY_CLOSED =
  'CEP_BULK_PROCESSING_SET_IS_DAY_CLOSED';
export const CEP_BULK_PROCESSING_LOADING_DAY_CLOSED =
  'CEP_BULK_PROCESSING_LOADING_DAY_CLOSED';



// WEBPACK FOOTER //
// ./src/pages/cepbulkprocessing/state/processing/types.js